module.exports = "//docs.gtimg.com/slide/img/framework/editor/src/img/pageIndex/toolbar/addGroup-db69a2.svg";